export enum EColors {
    ORANGE = "#FF8800",
    GREEN = "#007E33",
    SKY_BLUE = "#0099CC",
    BLUE = "#0d47a1",
    PURPLE = "#9933CC"
}
